<template>
  <div>
    <div id="hidden-price-container" class="hidden">
      {{ formattedPrice }}
    </div>
    <BannerBase background="bg-static-default-mid" class="mb-12 py-12" :isBusy>
      <!-- eslint-disable-next-line vue/component-name-in-template-casing -->
      <scalapay-widget
        amount-selectors='["#hidden-price-container"]'
        currency-display="symbol"
        currency-position="before"
        :environment="config.environment"
        :locale
        :merchant-token="config.merchantToken"
        type="checkout"
      ></scalapay-widget>
    </BannerBase>

    <DefaultRedirectionText
      v-if="props.paymentGroup"
      :group="props.paymentGroup"
    />

    <slot />
  </div>
</template>

<script lang="ts" setup>
import { computed, ref } from 'vue'

import type { ScalapayPaymentMethodConfig } from '@backmarket/http-api/src/api-specs-payment/payment/payment.types'
import { useI18n } from '@backmarket/nuxt-module-i18n/useI18n'
import { useI18nLocale } from '@backmarket/nuxt-module-i18n/useI18nLocale'

import BannerBase from '../../../../advertising/components/BannerBase/BannerBase.vue'
import { useScript } from '../../../../advertising/composables/useScript'
import type { PaymentFormAdornmentProps } from '../PaymentFormAdornment.type'

import DefaultRedirectionText from './DefaultRedirectionText.vue'

const i18n = useI18n()
const props = defineProps<PaymentFormAdornmentProps>()

const i18nLocale = useI18nLocale()

// Scalapay documentation is not explicit, but examples show a two-letter locale code, ex: 'en'
const locale = computed(() => i18nLocale.split('-')[0])

const formattedPrice = computed(() => i18n.price(props.basePrice))

const config = computed(
  () => (props.paymentMethod?.config || {}) as ScalapayPaymentMethodConfig,
)

const isBusy = ref(true)
const { onLoaded } = useScript({
  src: 'https://cdn.scalapay.com/widget/scalapay-widget-loader.js?version=V5',
  type: 'module',
})
onLoaded(() => {
  // TODO: is there a way to know when the Scalapay banner is rendered?
  isBusy.value = false
})
</script>
